import { render, staticRenderFns } from "./HeaderProfile.vue?vue&type=template&id=56da2065&scoped=true&"
import script from "./HeaderProfile.vue?vue&type=script&lang=js&"
export * from "./HeaderProfile.vue?vue&type=script&lang=js&"
import style0 from "./HeaderProfile.vue?vue&type=style&index=0&id=56da2065&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56da2065",
  null
  
)

export default component.exports